export var extractIsTrusted = function extractIsTrusted(meta) {
  return Boolean((meta === null || meta === void 0 ? void 0 : meta.key) && meta.key !== 'iframely-object-provider');
};